import { FormattedMessage } from "react-intl";

export function SignalUnreadLabel(props: { unreadCount: number }) {
  return (
    <FormattedMessage
      defaultMessage="{unreadCount, plural,
    one {# Unread}
    other {# Unread}
}"
      description="SignalTeamFeature unread count text"
      values={{
        unreadCount: props.unreadCount,
      }}
    />
  );
}
